import { memo, useEffect, useMemo, useRef, useCallback, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BzMasterAgGrid, BzChip, BzLoader } from '../../components';
import { MANAGE_COLUMNS_VIEW_TYPES, MARKET_OVER_VIEW_TAB_KEYS, ORDER_ENTRY_BUTTON_TOGGLE, WATCHLIST_GRID_INDEX, GRID_VIEW, MULTIPLIER, TL_INDEX, HEATMAP_COLURS, PROFIT_GROUP, LOSS_GROUP, CRORE, API_RESPONSE_STATUS, EQUITY_SERIES_LIST } from '../../utils/global_variables';
import {
    convertColumnsDatatoGridColumns, convertTOVariable, deepClone, displayZeroStateForGrid,
    convertNumberWithCommasForCurrency, dontMissCol, getFormattedNumbers, handleUpdateWatchlistGrid,
    isGuestUser, openOverviewModal, convertScripResponseWatchlistGrid, getApiExchangeNameFromMktSegId, openOrderEntryModal, handleScripUnsubScriptionOnUnMount, updateDontmissToArrRowData
} from '../../utils/global_functions';
import { getKeystats, setScripOverviewData, getConstituendsData, updateSelectedConstituentView } from '../../redux/actions/marketOverview';
import { useDispatch, useSelector } from 'react-redux';
import { sendTouchlineRequest } from '../../apis/web_socket';
import { useDebounce, useWFHMessages } from "../../hooks";
import DontMissChip from '../DontMiss/DontMissChip';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
import GridHeaderSearch from '../GridHeaderSearch';
import { PriceVolumeView, WatchlistGridPopover } from '../Watchlist';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { _getScripsInfo } from '../../controllers';
import { setIsIndicesOverview } from '../../redux/actions/indices';
// import { HoldingsHeatmap } from '../Portfolio';
import HeatmapView from './HeatmapView';
import { arrayMove } from 'react-sortable-hoc';
import ZeroStates from '../ZeroStates';


const Constituents = ({ toggleTabs }) => {
    let strSearch = null;

    const dispatch = useDispatch();
    const CONSTITUENT_GRID_REF = useRef();
    const scripOverviewData = useSelector(state => state.marketOverview.scripOverviewData);
    const constituentsData = useSelector(state => state.marketOverview.constituentsData);
    const constituentAPIStatus = useSelector(state => state.marketOverview.constituentAPIStatus);

    const objConstituentsIndexes = useSelector(state => state?.marketOverview?.objConstituentsIndexes);// Azeem K -05-07-2024 : Constituents Optimization
    const holdingsScrips = useSelector(state => state.holdings.holdingsScrips);
    const dontMissData = useSelector(state => state?.dontMiss?.dontMissData);
    const groupedDontMissData = useSelector(state => state?.dontMiss?.groupedDontMissData);
    const userColumnProfiles = useSelector(state => state?.watchList?.userColumnProfiles);

    //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices -- Issue - reference error so added deepClone --Start
    // Deepti B - BT-138260 - kebab menu implementation in constituent indices -start
    const selectedConstituentView = useSelector(state => state.marketOverview.constituentView);
    const objViewWiseColumnProfiles = useSelector(state => state.watchList.objViewWiseColumnProfiles);
    const [strConstituentView, setStrConstituentView] = useState(GRID_VIEW.DEFAULT_VIEW);
    const [arrcombinedData, setArrcombinedData] = useState([]);
    const [strSearchScrip, setStrSearchScrip] = useState('');
    const [heatMapToggle, setHeatMapToggle] = useState(0);
    const [arrHeatmap, setArrHeatmap] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const [arrConstituentData, setArrConstituentData] = useState([]);

    const constituentsTenantColumnProfiles = useMemo(() => {
        const constituentsColumDetails = deepClone(userColumnProfiles)?.find(eachProfile => eachProfile?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.CONSTITUENTS_VIEW_TYPE?.toLowerCase() && eachProfile?.bIsDefault);
        let settings = {};
        if (constituentsColumDetails) {
            const updatedColumnDetails = deepClone(constituentsColumDetails?.columnDetails)?.map((eachProfile) => {
                let originalField;
                if (typeof eachProfile.sSettings === 'string') {
                    settings = JSON?.parse(eachProfile?.sSettings);
                    originalField = deepClone(settings?.field);
                } else {
                    settings = { ...eachProfile?.sSettings };
                    originalField = deepClone(settings?.field);
                }
                eachProfile.sSettings = { ...settings, extraField: originalField, field: typeof settings?.field === "number" ? settings?.field.toString() : convertTOVariable(settings?.field) };
                return eachProfile;
            });
            return convertColumnsDatatoGridColumns(updatedColumnDetails, MANAGE_COLUMNS_VIEW_TYPES.CONSTITUENTS_VIEW_TYPE);
        } else {
            const updatedColumnDetails = objViewWiseColumnProfiles[MANAGE_COLUMNS_VIEW_TYPES.CONSTITUENTS_VIEW_TYPE]?.map((eachProfile) => {
                let originalField;
                if (typeof eachProfile.sSettings === 'string') {
                    settings = JSON?.parse(eachProfile?.sSettings);
                    originalField = deepClone(settings?.field);
                } else {
                    settings = { ...eachProfile?.sSettings };
                    originalField = deepClone(settings?.field);
                }
                eachProfile.sSettings = { ...settings, extraField: originalField, field: typeof settings?.field === "number" ? settings?.field.toString() : convertTOVariable(settings?.field) };
                return eachProfile;
            });
            const arrdDefaultColumns = updatedColumnDetails?.filter(eachColumn => eachColumn?.sSettings?.bIsFixed === "true" || eachColumn?.sSettings?.bIsDefault === "true");
            return convertColumnsDatatoGridColumns(arrdDefaultColumns, MANAGE_COLUMNS_VIEW_TYPES.CONSTITUENTS_VIEW_TYPE);
        }
    }, [userColumnProfiles, objViewWiseColumnProfiles]);

    //Hari k:17-10-2024:to update dontmiss data to constituent data-starts
    useEffect(() => {
        if (constituentsData?.length) {
            setArrConstituentData(updateDontmissToArrRowData(groupedDontMissData, constituentsData));
        } else { }
    }, [groupedDontMissData, constituentsData]);
    //Hari k:17-10-2024:to update dontmiss data to constituent data-end

    useEffect(() => {
        if (!selectedConstituentView) {
            setStrConstituentView(GRID_VIEW.DEFAULT_VIEW);
        } else {
            setStrConstituentView(selectedConstituentView);
        }
    }, [selectedConstituentView]);

    // Deepti B - BT-138260 - Heatmap view in constituent indices -start

    function getColor(value) {
        if (value === PROFIT_GROUP.ZERO) { return HEATMAP_COLURS.GRAY; }
        else if (value >= PROFIT_GROUP.TWO) { return HEATMAP_COLURS.GREEN; }
        else if (value >= PROFIT_GROUP.ONE) { return HEATMAP_COLURS.FERN_GREEN; }
        else if (value > PROFIT_GROUP.ZERO) { return HEATMAP_COLURS.FRUIT_SALAD; }
        else if (value >= LOSS_GROUP.MINUS_ONE) { return HEATMAP_COLURS.RED_DAREN; }
        else if (value >= LOSS_GROUP.MINUS_TWO) { return HEATMAP_COLURS.RED; }
        else if (value < LOSS_GROUP.MINUS_TWO) { return HEATMAP_COLURS.MANCHESTER_NIGHTS; }
    }

    useEffect(() => {
        strSearch = null;
        CONSTITUENT_GRID_REF?.current?.api?.onFilterChanged();
        if (strConstituentView === GRID_VIEW.HEAT_MAP) {
            const subscribeScrips = [];
            constituentsData.map(item => {
                subscribeScrips?.push({ exchangeId: item[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: item[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true });
            });
            sendTouchlineRequest(subscribeScrips);
        } else {
            const unSubscribeScrips = [];
            constituentsData.map(item => {
                unSubscribeScrips?.push({ exchangeId: item[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: item[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: false });
            });
            sendTouchlineRequest(unSubscribeScrips);
        }
    }, [strConstituentView]);

    useEffect(() => {
        // Deepti B. [Breez-14] [23/10/2014]: added market capitalization under Scrip name and valuation on heatmap tile
        setArrHeatmap([]);
        setIsLoader(true);
        setTimeout(() => {
            // last tick data from store
            const objLastTickData = dispatch(getWfhTouchlineLastTick());
            let tempArr = [];
            let arrTempHeatmapData = [];
            arrConstituentData?.forEach(x => {
                if (EQUITY_SERIES_LIST.includes(x[WATCHLIST_GRID_INDEX.SERIES])) {
                    tempArr.push(x);
                }
            });
            // Ajitesh - 02/05/2024 Block to find max size of a scrip and determine breakpoint size for small scrips - Start
            let allTileSizes = [];
            tempArr.forEach(e => {
                if (objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]) {
                    allTileSizes.push(parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES),);
                }
                else {
                    allTileSizes.push(parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS]) / MULTIPLIER.THOUSAND_CRORES));
                }
            });
            const maxTileSize = allTileSizes.reduce((prev, current) => {
                return prev > current ? prev : current;
            }, 0);
            const breakpointSize = parseFloat(maxTileSize / MULTIPLIER.HUNDRED);
            // Ajitesh - 02/05/2024 Block to find max size of a scrip and determine breakpoint size for small scrips - End
            if (heatMapToggle === 0) {
                tempArr?.forEach((e) => {
                    if (objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]) {
                        arrTempHeatmapData.push({
                            // sector : "",
                            name: e[WATCHLIST_GRID_INDEX.SYMBOL] + " (" + e[WATCHLIST_GRID_INDEX.EXCHANGE] + ")",
                            id: e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN],
                            valuation: parseFloat(objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.LAST_TRADE_PRICE]),
                            change: parseFloat(objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE]),
                            // If size > breakpoint then apply actual value; else apply minimal breakpoint value
                            size: parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES) > breakpointSize
                                ? parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES)
                                : breakpointSize,
                            color: getColor(parseFloat(objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE])),
                            marketCap: `${parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.CRORES).toFixed(2)} ${CRORE}`,
                        });
                    }
                    else {
                        arrTempHeatmapData.push({
                            // sector : "",
                            name: e[WATCHLIST_GRID_INDEX.SYMBOL] + " (" + e[WATCHLIST_GRID_INDEX.EXCHANGE] + ")",
                            valuation: parseFloat(e[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]),
                            change: parseFloat(e[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]),
                            id: e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN],
                            size: parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS]) / MULTIPLIER.THOUSAND_CRORES) > breakpointSize
                                ? parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS]) / MULTIPLIER.THOUSAND_CRORES)
                                : breakpointSize, // hari k:05-04-2024 changed the formula // index 14
                            color: getColor(parseFloat(e[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP])),
                            marketCap: `${parseFloat(e[WATCHLIST_GRID_INDEX.MARKET_CAPITALIZATION]).toFixed(2)} ${CRORE}`
                        });
                    }
                });
            }
            else {
                tempArr?.forEach((e) => {
                    if (objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]) {
                        if (arrTempHeatmapData.findIndex((x) => x.name === (e[WATCHLIST_GRID_INDEX.SECTOR] === "" ? "Other" : e[WATCHLIST_GRID_INDEX.SECTOR])) === -1) {
                            arrTempHeatmapData.push({

                                sector: (e[WATCHLIST_GRID_INDEX.SECTOR] === "" ? "Other" : e[WATCHLIST_GRID_INDEX.SECTOR]).toUpperCase(),
                                name: e[WATCHLIST_GRID_INDEX.SYMBOL] + " (" + e[WATCHLIST_GRID_INDEX.EXCHANGE] + ")",
                                valuation: parseFloat(objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.LAST_TRADE_PRICE]),
                                change: parseFloat(objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE]),
                                id: e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN],
                                size: parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES) > breakpointSize
                                    ? parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES)
                                    : breakpointSize,
                                color: getColor(parseFloat((objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE])) / MULTIPLIER.THOUSAND_CRORES),
                                marketCap: `${parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.CRORES).toFixed(2)} ${CRORE}`,

                            });

                        } else {
                            arrTempHeatmapData.push({
                                name: e[WATCHLIST_GRID_INDEX.SYMBOL] + " (" + e[WATCHLIST_GRID_INDEX.EXCHANGE] + ")",
                                valuation: parseFloat(objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.LAST_TRADE_PRICE]),
                                change: parseFloat(objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE]),
                                id: e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN],
                                size: parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES) > breakpointSize
                                    ? parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.CLOSE_PRICE]) / MULTIPLIER.THOUSAND_CRORES)
                                    : breakpointSize,
                                color: getColor(parseFloat(objLastTickData[e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]][TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE])),
                                marketCap: `${parseFloat(e[WATCHLIST_GRID_INDEX.MARKET_CAPITALIZATION]).toFixed(2)} ${CRORE}`

                            });

                        }
                    }
                    else {
                        if (arrTempHeatmapData.findIndex((x) => x.name === (e[WATCHLIST_GRID_INDEX.SECTOR] === "" ? "Other" : e[WATCHLIST_GRID_INDEX.SECTOR])) === -1) {
                            arrTempHeatmapData.push({
                                sector: (e[WATCHLIST_GRID_INDEX.SECTOR] === "" ? "Other" : e[WATCHLIST_GRID_INDEX.SECTOR]).toUpperCase(),
                                name: e[WATCHLIST_GRID_INDEX.SYMBOL] + " (" + e[WATCHLIST_GRID_INDEX.EXCHANGE] + ")",
                                valuation: parseFloat(e[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]),
                                change: parseFloat(e[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]),
                                id: e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN],
                                size: parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS]) / MULTIPLIER.THOUSAND_CRORES) > breakpointSize
                                    ? parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS]) / MULTIPLIER.THOUSAND_CRORES)
                                    : breakpointSize,// hari k:05-04-2024 changed the formula
                                color: getColor(parseFloat(e[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP])),
                                marketCap: `${parseFloat(e[WATCHLIST_GRID_INDEX.MARKET_CAPITALIZATION]).toFixed(2)} ${CRORE}`

                            });

                        }
                        else {
                            arrTempHeatmapData.push({
                                name: e[WATCHLIST_GRID_INDEX.SYMBOL] + " (" + e[WATCHLIST_GRID_INDEX.EXCHANGE] + ")",
                                valuation: parseFloat(e[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]),
                                change: parseFloat(e[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP]),
                                id: e[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN],
                                size: parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS]) / MULTIPLIER.THOUSAND_CRORES) > breakpointSize
                                    ? parseFloat((e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS] * e[WATCHLIST_GRID_INDEX.ISSUE_CAPITAL_IN_LACS]) / MULTIPLIER.THOUSAND_CRORES)
                                    : breakpointSize,// hari k:05-04-2024 changed the formula
                                color: getColor(parseFloat(e[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP])),
                                marketCap: `${parseFloat(e[WATCHLIST_GRID_INDEX.MARKET_CAPITALIZATION]).toFixed(2)} ${CRORE}`
                            });

                        }
                    }
                });
            }
            if (tempArr?.length === 0) {
                setArrHeatmap([]);
                setIsLoader(false);
                return;
            }
            setArrHeatmap(arrTempHeatmapData);
            setIsLoader(false);
        }, 500);
    }, [dispatch, arrConstituentData, heatMapToggle, strConstituentView]);

    // Deepti B: 04/09/2024: overview modal of respective scrip will open on heatmap tile click
    const handleChartOverview = (id) => {
        let rowData = arrConstituentData.find(ele => ele[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === id);
        dispatch(setScripOverviewData(rowData));
        dispatch(setIsIndicesOverview(false));
        dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }], true));
        dispatch(handleModalData({ ...modalData, tab: 'overview' }));
    };

    const onChangeToggleSector = (e) => {
        setHeatMapToggle(Number(e.target.checked));
    };

    // Deepti B - BT-138260 - Heatmap view in constituent indices - end

    // Deepti B - BT-138260 - kebab menu implementation in constituent indices - end



    //Ameersha N - 21-11-2023 :- BT-104813 -- Dashboard Indices --End


    //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices  --Start
    useEffect(() => {
        //Ameersha N - this useEffect is used to get keystats and constituents data when marketOveriewmodel is opened
        //Ameersha N - page size should be always 100 otherwise it gives data of limited size we have given
        const payload = { Exchange: scripOverviewData[WATCHLIST_GRID_INDEX?.EXCHANGE], IndexGroup: scripOverviewData[WATCHLIST_GRID_INDEX?.SYMBOL].toLowerCase(), Pagesize: 100 };
        const jtenantToken = 1;
        dispatch(getKeystats());
        dispatch(getConstituendsData(payload, jtenantToken, scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID]));

    }, [dispatch, scripOverviewData, groupedDontMissData]);
    //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices  --End







    const isExternalFilterPresent = useCallback(() => {
        return strSearch !== null;
    }, [strSearch]);

    const onChangeGridHeaderSearch = useCallback((e) => {
        strSearch = e?.target?.value;
        CONSTITUENT_GRID_REF?.current?.api?.onFilterChanged();
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- Start
        displayZeroStateForGrid(CONSTITUENT_GRID_REF);
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- End
    }, []);

    //Ameersha N : Breeze BT-104813 Dashboard Indices feature -- 06-11-2023 --Start
    const doesExternalFilterPass = useCallback(
        //Ameersha N : this will help in filtering columns of constituents grid
        (node) => {
            if (!strSearch) {
                return true;
            } else {
                const keywords = strSearch?.toLowerCase()?.split(' ');
                let arrData = node?.data[WATCHLIST_GRID_INDEX.SYMBOL]?.toLowerCase();
                const rowData = arrData?.split(' ')?.join('')?.toLowerCase();
                return keywords?.every(keyword => rowData?.includes(keyword));
            }
        },
        [strSearch]
    );
    //Ameersha N : Breeze BT-104813 Dashboard Indices feature -- 06-11-2023 --End


    //Vaibhav Singh: 22-12-23: BT-104813: Added Sortingcomaprator and sorted all the fields added text filter in dont miss: Start
    const sortingComparator = useCallback((number1, number2) => {
        number1 = parseFloat(number1);
        number2 = parseFloat(number2);
        if (number1 === null) {
            return 0.00;
        }
        if (number2 === null) {
            return 0.00;
        }
        return number1 - number2;
    }, []);

    const updateWatchlistGrid = (arrScripToBeUpdated) => {
        if (arrScripToBeUpdated?.length > 0) {// this condition is added to stop update the ag grid data when handleUpdateWatchlistGrid is not returning any value to stop error of agrid in console
            CONSTITUENT_GRID_REF?.current?.api?.applyTransaction({
                update: [arrScripToBeUpdated]
            });
        } else { }
    };

    useWFHMessages('touchline', (e) => {

        const arrScripToBeUpdated = handleUpdateWatchlistGrid([...e.detail], { scrips: arrConstituentData }, objConstituentsIndexes);// Azeem K -05-07-2024 : Constituents Optimization
        if (arrScripToBeUpdated?.length) {
            updateWatchlistGrid(arrScripToBeUpdated);
        } else { }
    });

    const getRowId = useCallback((params) => {
        if (params?.data) {
            return params?.data[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN];
        } else { }
    }, []);


    const onGridReady = useCallback(() => {
        strSearch = null;
        CONSTITUENT_GRID_REF?.current?.api?.onFilterChanged(); // Hari K : it will remove the previouse filters
    }, []);

    const symbolValueGetter = useCallback((params) => {
        if (dontMissCol) {
            const myColumn = params.data;
            return `${myColumn[WATCHLIST_GRID_INDEX.SYMBOL]}  ${myColumn[WATCHLIST_GRID_INDEX.EXCHANGE]} ${myColumn[WATCHLIST_GRID_INDEX.EXPIRYDATE]}`;
        } else {
            const myColumn = params.data;
            return `${myColumn[WATCHLIST_GRID_INDEX.SYMBOL]}`;
        }
    }, []);

    const dontMissValueGetter = useCallback((params) => {

        const myColumn = params.data;
        const dontMiss = dontMissData?.find(element => element[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === myColumn[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
        return dontMiss?.length ? dontMiss[WATCHLIST_GRID_INDEX.DONT_MISS] : [];

    }, [dontMissData]);


    // SrikanthR- 10-07-2024 :BT-138203 Require watchlist grid popover for scrips   --Start

    const SymbolCellRenderer = useCallback((params) => {
        const arrRowData = params?.data;
        // const WatchlistGridPopoverName = () => {
        //     if ((arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
        //         arrRowData[WATCHLIST_GRID_INDEX.INSTRUMENT])) {
        //         return (<div className='font-regular font-size4 color-subtext'>{`${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(0, 2)}  ${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(2, 5)} ${arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE]} ${arrRowData[WATCHLIST_GRID_INDEX.OPTIONTYPE]} `}</div>);
        //     } else if (!arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && !arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
        //         !arrRowData[WATCHLIST_GRID_INDEX.OPTIONTYPE]) {
        //         return (<div className='d-flex align-items-center'><div className='font-regular font-size4 color-subtext'>{arrRowData[WATCHLIST_GRID_INDEX.SERIES] || ''}</div></div>);
        //     }
        //     else if (arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && !arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE]) {
        //         return (
        //             <div className='font-regular font-size4 color-subtext'>{`${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(0, 2)}  ${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(2, 5)} ${arrRowData[WATCHLIST_GRID_INDEX.INSTRUMENT].slice(0, 3)} `}</div>
        //         );
        //     } else {
        //         return null;
        //     }
        // };

        return (
            <WatchlistGridPopover pageCalled={true} isAddtoWatchlist={true} arrRowData={params?.data} {...params}>
                <div className='scrip-wrap'>
                    {
                        arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS] !== "0" && arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0 &&
                        <div className='normal-scrip dontmiss-scrip'></div>
                    }
                    <div className='d-flex align-items-center'>
                        <div className='font-medium font-size4 color-text ms-3 text-uppercase'>{params.value}</div>
                        {arrRowData[WATCHLIST_GRID_INDEX.EXCHANGE]?.length ?
                            <div className='chips-wrap ms-2'>
                                <BzChip className='exchange-chip text-capitalize'>{arrRowData[WATCHLIST_GRID_INDEX.EXCHANGE]}</BzChip>
                            </div> : null}
                        {/* <div className='font-regular font-size4 color-subtext ms-2'>
                            <WatchlistGridPopoverName />
                        </div> */}
                        {
                            arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS] !== "0" && arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0 &&
                            <div className='icon-16 icon-dontmiss icon-yellow ms-2'></div>
                        }
                        {holdingsScrips?.some(element => element?.nMarketSegmentId + '_' + element?.nToken === arrRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) &&
                            <div className='icon-16 icon-portfolio icon-dark ms-2'></div>
                        }
                    </div>

                </div>
            </WatchlistGridPopover>);
    }, [holdingsScrips]);
    const numberValueFormatter = useCallback((value, arrRowData, ...props) => {
        const columnFiled = props[0]?.colDef?.field; // has column def value gives which column we are in
        if ((columnFiled === WATCHLIST_GRID_INDEX?.ASK_QTY?.toString()) ||
            (columnFiled === WATCHLIST_GRID_INDEX?.BID_QUANTITY?.toString())) {
            return value;
        } else if ((value > 0 && arrRowData?.length > 0 && typeof (value) === 'number') && (columnFiled === WATCHLIST_GRID_INDEX?.VOLUME?.toString())) {
            return convertNumberWithCommasForCurrency(value);
            // formatVolumeWithCommas(value);
        }
        else if ((value > 0 && arrRowData?.length > 0 && typeof (value) === 'number') &&
            ((columnFiled !== WATCHLIST_GRID_INDEX?.ASK_QTY?.toString()) ||
                (columnFiled !== WATCHLIST_GRID_INDEX?.BID_QUANTITY?.toString()) ||
                (columnFiled !== WATCHLIST_GRID_INDEX?.VOLUME?.toString()))) {
            return value?.toFixed(arrRowData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
        }
        else {
            return value;
        }
    }, []);
    const WatchlistRowData = ({ value, arrRowData, ...props }) => numberValueFormatter(value, arrRowData, { ...props });
    // SrikanthR- 10-07-2024 :BT-138203 Require watchlist grid popover for scrips   --end


    //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices   --Start
    const arrWatchlistColDefs = useMemo(() => {
        if (constituentsTenantColumnProfiles?.length > 0) {
            const arrColumnsList = constituentsTenantColumnProfiles?.map(item => {
                switch (Number(item.field)) {
                    case WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN: {
                        item = { ...item, hide: true };
                        return item;
                    }
                    case WATCHLIST_GRID_INDEX.SEGMENT_ID: {
                        item = { ...item, hide: true };
                        return item;
                    }
                    case WATCHLIST_GRID_INDEX.TOKEN: {
                        item = { ...item, hide: true };
                        return item;
                    }
                    case WATCHLIST_GRID_INDEX.SYMBOL: {
                        item = {
                            ...item, headerComponent: GridHeaderSearch, cellRenderer: SymbolCellRenderer,
                            headerComponentParams: { onChangeGridHeaderSearch, gridRef: CONSTITUENT_GRID_REF },
                            // colId: 'check',
                            width: 350,
                            valueGetter: (params) => symbolValueGetter(params),
                            pinned: 'left',
                            suppressMovable: true,
                            lockPosition: "left",
                            suppressNavigable: true,
                        };
                        return item;
                    }
                    case WATCHLIST_GRID_INDEX.DONT_MISS: {
                        return {
                            ...item,
                            cellRenderer: (props) => {
                                return (props?.value ?
                                    <WatchlistGridPopover pageCalled={true} isAddtoWatchlist={true} arrRowData={props?.data} {...props}>
                                        <div className='chips-wrap justify-content-center py-2'>
                                            <DontMissChip isShowAllChips {...props} />
                                        </div>
                                    </WatchlistGridPopover> : <></>);
                            }
                            ,
                            valueGetter: dontMissValueGetter,
                            filter: 'agTextColumnFilter',
                            filterParams: {
                                textMatcher: ({ filterOption, filterText, data }) => {
                                    if (filterText == null) {
                                        return false;
                                    } else {
                                        //Vaibhav Singh:01-02-24: BT-110050 Updated Don't Miss filter values: Start
                                        switch (filterOption) {
                                            case 'equals': {
                                                if (dontMissData?.find(ele => ele[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === data[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])?.length) {
                                                    const dontMissFind = [];
                                                    dontMissData?.find(ele => ele[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === data[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])[WATCHLIST_GRID_INDEX.DONT_MISS]?.forEach((ele) => {
                                                        if (ele?.event?.toLowerCase() === filterText?.toLowerCase()) {
                                                            dontMissFind.push(true);
                                                        } else {
                                                            dontMissFind.push(false);
                                                        }
                                                    });
                                                    return dontMissFind?.includes(true) ? true : false;
                                                } else {
                                                    return false;
                                                }
                                            }
                                            case 'contains': {
                                                if (dontMissData?.find(ele => ele[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === data[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])?.length) {
                                                    const dontMissFind = [];
                                                    dontMissData?.find(ele => ele[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === data[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])[WATCHLIST_GRID_INDEX.DONT_MISS]?.forEach((ele) => {
                                                        if (ele?.event?.toLowerCase()?.includes(filterText?.toLowerCase())) {
                                                            dontMissFind.push(true);
                                                        } else {
                                                            dontMissFind.push(false);
                                                        }
                                                    });

                                                    return dontMissFind?.includes(true) ? true : false;
                                                } else {
                                                    return false;
                                                }
                                            }
                                            case 'notEqual': {
                                                if (dontMissData?.find(ele => ele[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === data[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])?.length) {
                                                    const dontMissFind = [];
                                                    dontMissData?.find(ele => ele[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === data[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])[WATCHLIST_GRID_INDEX.DONT_MISS]?.forEach((ele) => {
                                                        if (ele?.event?.toLowerCase()?.includes(filterText?.toLowerCase())) {
                                                            dontMissFind.push(true);
                                                        } else {
                                                            dontMissFind.push(false);
                                                        }
                                                    });
                                                    return dontMissFind?.includes(true) ? false : true;
                                                } else {
                                                    return false;
                                                }
                                            }
                                            case 'startsWith': {
                                                if (dontMissData?.find(ele => ele[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === data[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])?.length) {
                                                    const dontMissFind = [];
                                                    dontMissData?.find(ele => ele[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === data[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])[WATCHLIST_GRID_INDEX.DONT_MISS]?.forEach((ele) => {
                                                        if (ele?.event?.toLowerCase()?.startsWith(filterText?.toLowerCase())) {
                                                            dontMissFind.push(true);
                                                        } else {
                                                            dontMissFind.push(false);
                                                        }
                                                    });
                                                    return dontMissFind?.includes(true) ? true : false;
                                                } else {
                                                    return false;
                                                }
                                            }
                                            case 'endsWith': {
                                                if (dontMissData?.find(ele => ele[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === data[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])?.length) {
                                                    const dontMissFind = [];
                                                    dontMissData?.find(ele => ele[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === data[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])[WATCHLIST_GRID_INDEX.DONT_MISS]?.forEach((ele) => {
                                                        if (ele?.event?.toLowerCase()?.endsWith(filterText?.toLowerCase())) {
                                                            dontMissFind.push(true);
                                                        } else {
                                                            dontMissFind.push(false);
                                                        }
                                                    });
                                                    return dontMissFind?.includes(true) ? true : false;
                                                } else {
                                                    return false;
                                                }
                                            }
                                            default:
                                                return false;
                                        }
                                    }
                                },
                                filterOptions: [
                                    'contains',
                                    'equals',
                                    'notEqual',
                                    'startsWith',
                                    'endsWith',
                                    'blank',
                                    'notBlank'
                                ]
                            },
                        };
                    }
                    //Vaibhav Singh:01-02-24: BT-110050 Updated Don't Miss filter values: End
                    case WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE: {
                        item = {
                            ...item, cellClassRules: {
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
                                'background-positive color-active-text': params => params?.data[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] === 'U',  // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                'background-negative color-active-text': params => params?.data[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] === 'D',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                '': params => params?.data[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] === 'S',  // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - End
                            },
                            filter: 'agTextColumnFilter',
                            valueFormatter: (params) => { return getFormattedNumbers(params?.value); },
                            filterParams: {
                                textMatcher: ({ filterOption, value, filterText }) => {
                                    if (filterText == null) {
                                        return false;
                                    } else {
                                        switch (filterOption) {
                                            case 'equals': {
                                                return parseFloat(filterText) === parseFloat(value);
                                            }
                                            case 'notEqual': {
                                                return parseFloat(filterText) !== parseFloat(value);
                                            }
                                            case 'lessThan': {
                                                return parseFloat(value) < parseFloat(filterText);
                                            }
                                            case 'lessThanOrEqual': {
                                                return parseFloat(value) <= parseFloat(filterText);
                                            }
                                            case 'greaterThan': {
                                                return parseFloat(value) > parseFloat(filterText);
                                            }
                                            case 'greaterThanOrEqual': {
                                                return parseFloat(value) >= parseFloat(filterText);
                                            }
                                            default:
                                                return false;
                                        }
                                    }
                                },
                                filterOptions: [
                                    'equals',
                                    'notEqual',
                                    'lessThan',
                                    'lessThanOrEqual',
                                    'greaterThan',
                                    'greaterThanOrEqual',
                                ]
                            }, comparator: sortingComparator,
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover pageCalled={true} isAddtoWatchlist={true} arrRowData={arrRowData} {...props}>
                                <WatchlistRowData value={value} arrRowData={arrRowData} props={props} />
                            </WatchlistGridPopover>,

                        };
                        return item;
                    }
                    //Vaibhav Singh: 14-02-24: BT-104813: Issue with + and - resolved : Start
                    case WATCHLIST_GRID_INDEX.CHANGE_IN_LTP: {
                        item = {
                            ...item, cellClassRules: {
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
                                'color-positive': params => params?.data[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.split("")[0] === '+' || params?.value?.toString()?.includes('+') || !params?.data[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.includes('+'),     // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                'color-negative': params => params?.data[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.split("")[0] === '-',     // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - End
                            },
                            filter: 'agTextColumnFilter',
                            valueFormatter: (params) => { return params?.value > 0 ? `+${getFormattedNumbers(params?.value)}` : getFormattedNumbers(params?.value); },
                            filterParams: {
                                textMatcher: ({ filterOption, value, filterText }) => {
                                    if (filterText == null) {
                                        return false;
                                    } else {
                                        switch (filterOption) {
                                            case 'equals': {
                                                return parseFloat(filterText) === parseFloat(value);
                                            }
                                            case 'notEqual': {
                                                return parseFloat(filterText) !== parseFloat(value);
                                            }
                                            case 'lessThan': {
                                                return parseFloat(value) < parseFloat(filterText);
                                            }
                                            case 'lessThanOrEqual': {
                                                return parseFloat(value) <= parseFloat(filterText);
                                            }
                                            case 'greaterThan': {
                                                return parseFloat(value) > parseFloat(filterText);
                                            }
                                            case 'greaterThanOrEqual': {
                                                return parseFloat(value) >= parseFloat(filterText);
                                            }
                                            default:
                                                return false;
                                        }
                                    }
                                },
                                filterOptions: [
                                    'equals',
                                    'notEqual',
                                    'lessThan',
                                    'lessThanOrEqual',
                                    'greaterThan',
                                    'greaterThanOrEqual',
                                ]
                            }, comparator: sortingComparator,
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover pageCalled={true} isAddtoWatchlist={true} arrRowData={arrRowData} {...props}>
                                <WatchlistRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,

                        };
                        return item;
                    }
                    case WATCHLIST_GRID_INDEX.LTP_PERCENT: {
                        item = {
                            ...item, cellClassRules: {
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
                                'color-positive': params => params?.data[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.split("")[0] === '+' || params?.value?.toString()?.includes('+') || !params?.data[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.includes('+'),   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                'color-negative': params => params?.data[WATCHLIST_GRID_INDEX.LTP_PERCENT]?.split("")[0] === '-',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences -End
                            },
                            filter: 'agTextColumnFilter',
                            valueFormatter: (params) => { return params?.value > 0 ? `+${getFormattedNumbers(params?.value)}` : getFormattedNumbers(params?.value); },
                            filterParams: {
                                textMatcher: ({ filterOption, value, filterText }) => {
                                    if (filterText == null) {
                                        return false;
                                    } else {
                                        switch (filterOption) {
                                            case 'equals': {
                                                return parseFloat(filterText) === parseFloat(value);
                                            }
                                            case 'notEqual': {
                                                return parseFloat(filterText) !== parseFloat(value);
                                            }
                                            case 'lessThan': {
                                                return parseFloat(value) < parseFloat(filterText);
                                            }
                                            case 'lessThanOrEqual': {
                                                return parseFloat(value) <= parseFloat(filterText);
                                            }
                                            case 'greaterThan': {
                                                return parseFloat(value) > parseFloat(filterText);
                                            }
                                            case 'greaterThanOrEqual': {
                                                return parseFloat(value) >= parseFloat(filterText);
                                            }
                                            default:
                                                return false;
                                        }
                                    }
                                },
                                filterOptions: [
                                    'equals',
                                    'notEqual',
                                    'lessThan',
                                    'lessThanOrEqual',
                                    'greaterThan',
                                    'greaterThanOrEqual',
                                ]
                            }, comparator: sortingComparator,
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover pageCalled={true} isAddtoWatchlist={true} arrRowData={arrRowData} {...props}>
                                <WatchlistRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                        };
                        return item;
                    }
                    //Vaibhav Singh: 14-02-24: BT-104813: Issue with + and - resolved : End
                    case WATCHLIST_GRID_INDEX.BID_PRICE: {
                        item = {
                            ...item, cellClassRules: {
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - Start
                                'background-positive color-active-text': params => params?.data[WATCHLIST_GRID_INDEX.BID_PRICE_INDICATOR] === 'U',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                'background-negative color-active-text': params => params?.data[WATCHLIST_GRID_INDEX.BID_PRICE_INDICATOR] === 'D',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                '': params => params?.data[WATCHLIST_GRID_INDEX.BID_PRICE_INDICATOR] === 'S',   // Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                //Prachi T - 29-11-2023 - BT-110050 - Breeze- Settings Preferences - End
                            },
                            valueFormatter: (params) => { return getFormattedNumbers(params?.value); },
                            comparator: sortingComparator,
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover pageCalled={true} isAddtoWatchlist={true} arrRowData={arrRowData} {...props}>
                                <WatchlistRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                        };
                        return item;
                    }
                    case WATCHLIST_GRID_INDEX.ASK_PRICE: {
                        item = {
                            ...item,
                            cellClassRules: {
                                'watchlist-ag-grid-positive-cell': params => params?.data[WATCHLIST_GRID_INDEX.ASK_PRICE_INDICATOR] === 'U',   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                'watchlist-ag-grid-negative-cell': params => params?.data[WATCHLIST_GRID_INDEX.ASK_PRICE_INDICATOR] === 'D',   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                'watchlist-ag-grid-transparent-cell': params => params?.data[WATCHLIST_GRID_INDEX.ASK_PRICE_INDICATOR] === 'S',   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                            }, cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover pageCalled={true} isAddtoWatchlist={true} arrRowData={arrRowData} {...props}>
                                <WatchlistRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                            comparator: sortingComparator,
                        };
                        return item;
                    }
                    case WATCHLIST_GRID_INDEX.ASK_QTY: {
                        item = {
                            ...item,
                            comparator: sortingComparator,
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover pageCalled={true} isAddtoWatchlist={true} arrRowData={arrRowData} {...props}>
                                <WatchlistRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                        };
                        return item;
                    }
                    case WATCHLIST_GRID_INDEX.HIGH: {
                        item = {
                            ...item,
                            comparator: sortingComparator,
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover pageCalled={true} isAddtoWatchlist={true} arrRowData={arrRowData} {...props}>
                                <WatchlistRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                        };
                        return item;
                    }
                    case WATCHLIST_GRID_INDEX.LOW: {
                        item = {
                            ...item,
                            comparator: sortingComparator,
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover pageCalled={true} isAddtoWatchlist={true} arrRowData={arrRowData} {...props}>
                                <WatchlistRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                        };
                        return item;
                    }
                    case WATCHLIST_GRID_INDEX.OPEN: {
                        item = {
                            ...item,
                            comparator: sortingComparator,
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover pageCalled={true} isAddtoWatchlist={true} arrRowData={arrRowData} {...props}>
                                <WatchlistRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                        };
                        return item;
                    }
                    case WATCHLIST_GRID_INDEX.CLOSE: {
                        item = {
                            ...item,
                            comparator: sortingComparator,
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover pageCalled={true} isAddtoWatchlist={true} arrRowData={arrRowData} {...props}>
                                <WatchlistRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                        };
                        return item;
                    }
                    case WATCHLIST_GRID_INDEX.VOLUME: {
                        item = {
                            ...item,
                            comparator: sortingComparator,
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover pageCalled={true} isAddtoWatchlist={true} arrRowData={arrRowData} {...props}>
                                <WatchlistRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                        };
                        return item;
                    }
                    case WATCHLIST_GRID_INDEX.ATP: {
                        item = {
                            ...item,
                            comparator: sortingComparator,
                            cellRenderer: ({ data: arrRowData, value, ...props }) => <WatchlistGridPopover pageCalled={true} isAddtoWatchlist={true} arrRowData={arrRowData} {...props}>
                                <WatchlistRowData value={value} arrRowData={arrRowData} {...props} />
                            </WatchlistGridPopover>,
                        };
                        return item;
                    }
                    default:
                        return item;
                }
            });
            //Vaibhav Singh: 22-12-23: BT-104813: Added Sortingcomaprator and sorted all the fields added text filter in dont miss: End
            //Added getRowCellRendererParams : ManasaB : 13/07/2023 - End
            //BT-112513 Closing side menu on right click of grid and opening Gridpopover on right click of grid for each cell: ManasaB : 04/07/23 - End
            const nIndex = constituentsTenantColumnProfiles?.findIndex(elem => elem?.headerName === '');
            if (nIndex >= 0) {
                arrColumnsList[nIndex] = {
                    colId: "check",
                    hide: true,
                    headerCheckboxSelection: true,
                    checkboxSelection: true,
                    showDisabledCheckboxes: true,
                    pinned: 'left',
                    width: '40'
                };
            } else { }
            return arrColumnsList;
        } else {
            return [];
        }

    }, [constituentsTenantColumnProfiles, userColumnProfiles]);
    //Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices   --End

    // Vinit R : 26-07-2024 Open market overview modal -- Start
    const modalData = useSelector(state => state?.modals?.modalData);

    const handleOverview = useCallback((e) => {
        e.preventDefault(); // Prevent the default browser behavior for F5 key press
        if (!isGuestUser()) {
            if (CONSTITUENT_GRID_REF?.current?.api.getSelectedRows().length > 0) {
                dispatch(setIsIndicesOverview(false));
                const arrSelectedRowScripData = CONSTITUENT_GRID_REF?.current?.api?.getSelectedRows()[0];
                const bIsShowingGridCheckboxes = CONSTITUENT_GRID_REF?.current?.columnApi?.getColumn(
                    CONSTITUENT_GRID_REF?.current?.columnApi?.columnModel?.columnDefs[0]?.colId
                )?.visible;
                if (!bIsShowingGridCheckboxes && arrSelectedRowScripData?.length > 0) {
                    openOverviewModal(false, arrSelectedRowScripData, false, false, dispatch, modalData);
                }
            }
            else { }
        }
        else {
            dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
        }
    }, [dispatch, modalData, CONSTITUENT_GRID_REF]);

    // useSingleKey('f5', handleOverview);
    // Vinit R : 26-07-2024 Open market overview modal -- End

    const handleWatchlistViewChange = (each) => {
        dispatch(updateSelectedConstituentView(each));
    };

    const onSortEnd = ({ oldIndex, newIndex }) => {
        setArrcombinedData(items => {
            return arrayMove(items, oldIndex, newIndex);
        });
    };
    const objLoginSession = useSelector(state => state.auth?.objLoginSession);

    // useSingleKey('f1', async (e) => {
    //     // For Buy Order Entry ShortCut
    //     e.preventDefault(); // Prevent the default browser behavior for F1 key press
    //     if (!isGuestUser()) {
    //         if (CONSTITUENT_GRID_REF?.current?.api.getSelectedRows().length > 0) {
    //             const arrSelectedRowScripData = CONSTITUENT_GRID_REF?.current?.api?.getSelectedRows()[0];
    //             const scripDataRes = await _getScripsInfo([{ mkt: getApiExchangeNameFromMktSegId(arrSelectedRowScripData[WATCHLIST_GRID_INDEX.SEGMENT_ID]), token: arrSelectedRowScripData[WATCHLIST_GRID_INDEX.TOKEN] }]);
    //             const scripDataObj = scripDataRes?.data?.objScripsResp?.result;
    //             const scripData = convertScripResponseWatchlistGrid(scripDataObj)[0];
    //             if (scripData?.length > 0) {
    //                 openOrderEntryModal(arrSelectedRowScripData, scripData, objLoginSession, null, null, ORDER_ENTRY_BUTTON_TOGGLE.BUY);
    //                 dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }]));
    //             } else { }
    //         } else { }
    //     }
    //     else {
    //         dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
    //     }
    // });

    // useSingleKey('f2', async (e) => {
    //     // For Sell Order Entry ShortCut
    //     e.preventDefault(); // Prevent the default browser behavior for F2 key press
    //     if (!isGuestUser()) {
    //         if (CONSTITUENT_GRID_REF?.current?.api.getSelectedRows().length > 0) {
    //             const arrSelectedRowScripData = CONSTITUENT_GRID_REF?.current?.api?.getSelectedRows()[0];
    //             const scripDataRes = await _getScripsInfo([{ mkt: getApiExchangeNameFromMktSegId(arrSelectedRowScripData[WATCHLIST_GRID_INDEX.SEGMENT_ID]), token: arrSelectedRowScripData[WATCHLIST_GRID_INDEX.TOKEN] }]);
    //             const scripDataObj = scripDataRes?.data?.objScripsResp?.result;
    //             const scripData = convertScripResponseWatchlistGrid(scripDataObj)[0];
    //             if (scripData?.length > 0) {
    //                 openOrderEntryModal(scripData, scripData, objLoginSession, null, null, ORDER_ENTRY_BUTTON_TOGGLE.SELL);
    //                 dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }]));

    //             } else { }
    //         } else { }
    //     }
    //     else {
    //         dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
    //     }
    // });


    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --Start
    const [objScripsRequest, setObjScripsRequest] = useState({});
    const handleVisibleRows = useCallback(() => {
        setObjScripsRequest(prevState => {
            let objpreviosScripsCopy = prevState;
            let arrWithKeys = [];
            let subscribeScrips = []; // This array is a non repeated subscrips for subscription
            let unSubScribeScrips = []; // this array is scrips of unsubscription]
            const arrVisibleRows = CONSTITUENT_GRID_REF?.current?.api?.getRenderedNodes().map(item => {
                let id = item?.data[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN];
                arrWithKeys?.push(id);
                if (!objpreviosScripsCopy[id]) {
                    objpreviosScripsCopy[id] = true;
                    subscribeScrips?.push({ exchangeId: item?.data[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: item?.data[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true });

                }
                return { exchangeId: item?.data[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: item?.data[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true };
            });
            Object?.keys(objpreviosScripsCopy)?.forEach(key => {
                if (!arrWithKeys.includes(key)) {
                    let obj = {
                        exchangeId: Number(key?.split('_')[0]),
                        token: Number(key?.split('_')[1]),
                        isSubscribe: false
                    };
                    unSubScribeScrips?.push(obj);
                    delete objpreviosScripsCopy[key];
                }
            });
            sendTouchlineRequest(unSubScribeScrips);
            sendTouchlineRequest(subscribeScrips);
            useDebounce(() => {
                const lastTickData = dispatch(getWfhTouchlineLastTick());
                arrVisibleRows?.forEach((eachScrip) => {
                    let selectedScrip = lastTickData[`${eachScrip?.exchangeId + '_' + eachScrip?.token}`];
                    if (selectedScrip?.length > 0) {
                        const arrScripToBeUpdated = handleUpdateWatchlistGrid([...selectedScrip], { scrips: arrConstituentData }, objConstituentsIndexes);
                        updateWatchlistGrid(arrScripToBeUpdated);
                    }
                });

            }, 1000);
            return { ...objpreviosScripsCopy };
        });
    }, [dispatch, arrConstituentData, objConstituentsIndexes]);
    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --End

    //Ameersha N-- unsubscribing of scrips when components unmounts of which scrips were send for subscription -- Start
    useEffect(() => {
        return (() => {
            if (Object?.keys(objScripsRequest)?.length > 0) {
                handleScripUnsubScriptionOnUnMount(objScripsRequest, MARKET_OVER_VIEW_TAB_KEYS?.CONSTITUENTS);
            }
        });
    }, []);
    //Ameersha N-- unsubscribing of scrips when components unmounts of which scrips were send for subscription -- End

    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --Start
    const handleScrollEnd = async (e) => {
        if (e.direction === 'vertical') {
            handleVisibleRows();

        }
    };
    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --End

    useEffect(() => {
        setTimeout(() => {
            handleVisibleRows();
        }, 1000);
    }, [arrConstituentData, handleVisibleRows]);


    const handleKeyEvents = useCallback(async (e) => {
        let key = e?.key?.toLowerCase();
        switch (key) {


            case 'f1':
                e.preventDefault(); // Prevent the default browser behavior for F1 key press
                if (!isGuestUser()) {
                    if (CONSTITUENT_GRID_REF?.current?.api.getSelectedRows().length > 0) {
                        const arrSelectedRowScripData = CONSTITUENT_GRID_REF?.current?.api?.getSelectedRows()[0];
                        const scripDataRes = await _getScripsInfo([{ mkt: getApiExchangeNameFromMktSegId(arrSelectedRowScripData[WATCHLIST_GRID_INDEX.SEGMENT_ID]), token: arrSelectedRowScripData[WATCHLIST_GRID_INDEX.TOKEN] }]);
                        const scripDataObj = scripDataRes?.data?.objScripsResp?.result;
                        const scripData = convertScripResponseWatchlistGrid(scripDataObj)[0];
                        if (scripData?.length > 0) {
                            openOrderEntryModal(arrSelectedRowScripData, scripData, objLoginSession, null, null, ORDER_ENTRY_BUTTON_TOGGLE.BUY);
                            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }]));
                        } else { }
                    } else { }
                }
                else {
                    dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
                }
                break;
            case 'f2':
                e.preventDefault(); // Prevent the default browser behavior for F2 key press
                if (!isGuestUser()) {
                    if (CONSTITUENT_GRID_REF?.current?.api.getSelectedRows().length > 0) {
                        const arrSelectedRowScripData = CONSTITUENT_GRID_REF?.current?.api?.getSelectedRows()[0];
                        const scripDataRes = await _getScripsInfo([{ mkt: getApiExchangeNameFromMktSegId(arrSelectedRowScripData[WATCHLIST_GRID_INDEX.SEGMENT_ID]), token: arrSelectedRowScripData[WATCHLIST_GRID_INDEX.TOKEN] }]);
                        const scripDataObj = scripDataRes?.data?.objScripsResp?.result;
                        const scripData = convertScripResponseWatchlistGrid(scripDataObj)[0];
                        if (scripData?.length > 0) {
                            openOrderEntryModal(scripData, scripData, objLoginSession, null, null, ORDER_ENTRY_BUTTON_TOGGLE.SELL);
                            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }]));

                        } else { }
                    } else { }
                }
                else {
                    dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
                }
                break;
            case 'f5':
                handleOverview(e);
                break;
            default: break;
        }
    }, [dispatch, handleOverview, CONSTITUENT_GRID_REF, objLoginSession]);

    useEffect(() => {
        document.addEventListener('keydown', handleKeyEvents);
        return () => {
            document.removeEventListener('keydown', handleKeyEvents);
        };
    }, [handleKeyEvents]);
    return (
        <>
            <Container fluid className='p-0'>
                {arrConstituentData && arrConstituentData?.length && constituentAPIStatus === API_RESPONSE_STATUS.SUCCESS ?
                    <Row className='g-0'>
                        <Col>
                            {strConstituentView === GRID_VIEW.DEFAULT_VIEW ?
                                <BzMasterAgGrid
                                    gridProfileType={MANAGE_COLUMNS_VIEW_TYPES?.CONSTITUENTS_VIEW_TYPE}
                                    onBodyScrollEnd={handleScrollEnd}
                                    rowBuffer={1}
                                    ref={CONSTITUENT_GRID_REF}
                                    getRowId={getRowId}
                                    onGridReady={onGridReady}
                                    arrColumnData={arrWatchlistColDefs}
                                    arrRowData={arrConstituentData}
                                    rowHeight={36}
                                    className='ag-theme-alpine constituents-ag-grid-height' // Removed inline style and add Class added regarding height and with SAT-BT-104813
                                    doesExternalFilterPass={doesExternalFilterPass}
                                    isExternalFilterPresent={isExternalFilterPresent}
                                    gridKey={"constituent"}
                                />
                                :
                                strConstituentView === GRID_VIEW.PRICE_VOLUME_VIEW ?
                                    <PriceVolumeView ref={CONSTITUENT_GRID_REF} useDragHandle arrRowData={arrConstituentData} handleWatchlistViewChange={handleWatchlistViewChange}
                                        arrcombinedData={arrcombinedData} setArrcombinedData={setArrcombinedData} onSortEnd={onSortEnd} strSearchScrip={strSearchScrip} setStrSearchScrip={setStrSearchScrip} isConstituent={true} />
                                    :
                                    strConstituentView === GRID_VIEW.HEAT_MAP ?
                                        <HeatmapView toggleTabs={toggleTabs} arrHeatmap={arrHeatmap} heatMapToggle={heatMapToggle} selectedScripData={arrConstituentData} setHeatMapToggle={setHeatMapToggle} isLoader={isLoader} handleChartOverview={handleChartOverview} onChangeToggleSector={onChangeToggleSector} handleWatchlistViewChange={handleWatchlistViewChange} pageCalled={true} /> : ''
                            }
                        </Col>
                    </Row> : constituentAPIStatus === API_RESPONSE_STATUS.PENDING ?
                        <div className='zero-state-alerts zero-state-alerts-lg'>
                            <BzLoader spinner={constituentAPIStatus === API_RESPONSE_STATUS.PENDING} spinnerContent={"Fetching Details"} />
                        </div> : <div className='zero-state-alerts zero-state-alerts-xl'>
                            <ZeroStates subText="No data available" icon='icon-64 icon-nodata mb-3 mrgauto' />
                        </div>}
            </Container>
        </>
    );
};

export default memo(Constituents);